'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _module = angular.module('cb.strips.cbContentVideo', []);

_module.directive('cbContentVideoV1', cbContentVideoV1);

exports.default = _module;


function cbContentVideoV1() {
    return {
        restrict: 'A',
        scope: {},
        link: cbContentVideoV1Link
    };

    function cbContentVideoV1Link(scope, element, attr) {
        var version = 1.00;
        var container = element[0];

        var videoContainerClass = 'content-video__ytplayer';
        var videoIsPlayingClass = 'content-video--is-playing';

        if (attr.videoId) {
            container.addEventListener('click', playVideo);
        }

        function playVideo() {
            container.removeEventListener('click', playVideo);

            var iframe = document.createElement('iframe');
            iframe.className = videoContainerClass;
            iframe.type = 'text/html';
            iframe.src = 'https://www.youtube-nocookie.com/embed/' + attr.videoId + '?autoplay=1&modestbranding=1';
            iframe.frameBorder = '0';

            container.insertBefore(iframe, container.firstChild);
            container.classList.add(videoIsPlayingClass);

            setVideoContainerHeight();
        }

        function setVideoContainerHeight() {
            var disableAnimatableClass = function disableAnimatableClass() {
                container.classList.remove('content-video--animatable');
                container.removeEventListener('transitionend', disableAnimatableClass);
            };

            container.addEventListener('transitionend', disableAnimatableClass);

            container.classList.add('content-video--animatable');

            var height = container.offsetWidth / (16 / 9);

            // Set a sensible max height
            if (height >= 960) {
                height = 960;
            }

            requestAnimationFrame(function () {
                return container.style.height = Math.round(height) + 'px';
            });
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/cb-content-video.directive.js
// module id = 859
// module chunks = 0